import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDeletedIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 200,
	height: 140,
	viewBox: "0 0 200 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			id: "Illustrations-2",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					width: 200,
					height: 140,
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector 1125",
					d: "M89.1382 26.1623C69.7027 44.467 64.4613 58.2684 48.8132 66.5333C38.8632 71.7886 27.4076 75.6469 21.53 85.2424C0.121438 120.193 45.7558 148.941 75.1378 114.66C100.056 85.5876 138.265 153 174.637 98.1602C207.137 49.1608 140.637 -22.3407 89.1382 26.1623Z",
					fill: "#F0FAF8"
				}),
				/* @__PURE__ */ _jsx("circle", {
					id: "Ellipse 592",
					cx: 89.6406,
					cy: 120.66,
					r: 6,
					fill: "#F0FAF8"
				}),
				/* @__PURE__ */ _jsx("circle", {
					id: "Ellipse 593",
					cx: 40.6406,
					cy: 35.6602,
					r: 8,
					fill: "#F0FAF8"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector 1152",
					d: "M125 52H75L80.2669 97.9118C80.7302 101.951 84.1492 105 88.2147 105H111.785C115.851 105 119.27 101.951 119.733 97.9118L125 52Z",
					fill: "url(#paint0_linear_2015_5654)"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector 1153",
					d: "M82 46H72C70.8954 46 70 46.8954 70 48V50C70 51.1046 70.8954 52 72 52H128C129.105 52 130 51.1046 130 50V48C130 46.8954 129.105 46 128 46H118C115.239 46 113 43.7614 113 41C113 38.2386 110.761 36 108 36H92C89.2386 36 87 38.2386 87 41C87 43.7614 84.7614 46 82 46Z",
					fill: "url(#paint1_linear_2015_5654)"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector 1154",
					d: "M94 65H106",
					stroke: "url(#paint2_linear_2015_5654)",
					strokeWidth: 4,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector 1155",
					d: "M94 77H106",
					stroke: "url(#paint3_linear_2015_5654)",
					strokeWidth: 4,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector 1156",
					d: "M94 89H106",
					stroke: "url(#paint4_linear_2015_5654)",
					strokeWidth: 4,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("circle", {
					id: "Ellipse 596",
					cx: 125,
					cy: 75,
					r: 13.25,
					fill: "#DB5543",
					stroke: "white",
					strokeWidth: 1.5
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Ellipse 604",
					d: "M129 80C128.061 78.7807 126.618 78 125 78C123.382 78 121.939 78.7807 121 80",
					stroke: "white",
					strokeWidth: 2,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector 1134",
					d: "M119 71H122",
					stroke: "white",
					strokeWidth: 2,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector 1135",
					d: "M128 71H131",
					stroke: "white",
					strokeWidth: 2,
					strokeLinecap: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_2015_5654",
				x1: 76.9068,
				y1: 54.6949,
				x2: 124.014,
				y2: 99.5588,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6BCABA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#ACE1D8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_2015_5654",
				x1: 72.2881,
				y1: 36.8136,
				x2: 79.3194,
				y2: 63.4321,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#865E9C" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B69CC4"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_2015_5654",
				x1: 94.4576,
				y1: 65.0508,
				x2: 94.6035,
				y2: 66.8185,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#471BBB"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_2015_5654",
				x1: 94.4576,
				y1: 77.0508,
				x2: 94.6035,
				y2: 78.8185,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#471BBB"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_2015_5654",
				x1: 94.4576,
				y1: 89.0508,
				x2: 94.6035,
				y2: 90.8185,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#471BBB"
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgDeletedIcon);
export { ForwardRef as ReactComponent };
